import {
  ContingencyPlanType,
  CreateStep2Body,
  NewStep2ApprovalForm,
  ResponsePostCto,
  Response,
} from "../../types";
import {
  buildResponse,
  callWorkflowDelete,
  callWorkflowGET,
  callWorkflowPOST,
  callWorkflowPOST_V3,
  callWorkflowPOST_V4,
  callWorkflowPUT,
} from "../generic";
import { CTO_ENDPOINTS } from "./endpoints";

export const getContingencyPlansSlice = (vesselCode: string) =>
  callWorkflowGET<ContingencyPlanType[]>(
    CTO_ENDPOINTS.VESSEL_CONTINGENCY_PLAN(vesselCode),
  );

export const postContingencyPlanSlice = (
  vesselCode: string,
  body: ContingencyPlanType,
) =>
  callWorkflowPOST<ContingencyPlanType, ContingencyPlanType>(
    CTO_ENDPOINTS.VESSEL_CONTINGENCY_PLAN(vesselCode),
    body,
  );

export const deleteContingencyPlanSlice = (
  vesselCode: string,
  contingencyPlanCode: string,
) =>
  callWorkflowDelete<ContingencyPlanType>(
    CTO_ENDPOINTS.VESSEL_CONTINGENCY_PLAN_ITEM(vesselCode, contingencyPlanCode),
  );

export const putContingencyPlanSlice = (
  vesselCode: string,
  body: ContingencyPlanType,
  contingencyPlanCode?: string,
) =>
  callWorkflowPUT<ContingencyPlanType, ContingencyPlanType>(
    CTO_ENDPOINTS.VESSEL_CONTINGENCY_PLAN_ITEM(
      vesselCode,
      contingencyPlanCode!,
    ),
    body,
  );

export const postCreateStep2 = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2Body,
  setObject: (obj: Response<ResponsePostCto>) => void,
): void => {
  const response = callWorkflowPOST<ResponsePostCto, CreateStep2Body>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION(vesselCode, ctoCode),
    body,
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const postCreateNewStep2 = (
  vesselCode: string,
  ctoCode: string,
  body: CreateStep2Body,
  setObject: (obj: Response<ResponsePostCto>) => void,
): void => {
  const response = callWorkflowPOST_V4<ResponsePostCto, CreateStep2Body>(
    CTO_ENDPOINTS.VESSEL_CTO_EVALUATION(vesselCode, ctoCode),
    body,
  );
  buildResponse<ResponsePostCto>(response, setObject);
};

export const postApproveNewStep2 = (
  vesselCode: string,
  ctoCode: string,
  body: NewStep2ApprovalForm,
  setObject: (obj: Response<ResponsePostCto>) => void,
): void => {
  const response = callWorkflowPOST_V3<ResponsePostCto, NewStep2ApprovalForm>(
    CTO_ENDPOINTS.VESSEL_CTO_INITIATION_APPROVE(vesselCode, ctoCode),
    body,
  );
  buildResponse<ResponsePostCto>(response, setObject);
};
